import { render, staticRenderFns } from "./BenefitsTableValue.vue?vue&type=template&id=73701c0e&"
import script from "./BenefitsTableValue.vue?vue&type=script&lang=js&"
export * from "./BenefitsTableValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports